module.exports = __webpack_public_path__ + "0e65a781916b98040db71ef766438582.svg";